<p-progressSpinner *ngIf="!breach.initialized" [style]="{width: '50px', height: '50px'}" fxFlex="1 1 auto" class="spinner"  animationDuration="2s"></p-progressSpinner>


<div *ngIf="breach.initialized" fxFlex="auto" fxLayout="row" class="trend-metric corner-triangle" [ngStyle]="{'background-color':  breachColor}">
    <div  fxFlex="1 1 35%">
        <div class="chartwrapper">
            <div [attr.id]="breach.chartDivName" class="chartdiv"></div>
        </div>
    </div>
    <span  fxFlex="1 1 30" class="trend-metric-value liquitics-h1">{{breach.daysOk}}</span>
    <div  fxFlex="1 1 30%" class="trend-metric-delta">
        <span>{{breach.delta}}</span>
        <span *ngIf="breach.delta > 0" class="fa fa-caret-up"></span>
        <span *ngIf="breach.delta === 0" class="fa fa-sort"></span>
        <span *ngIf="breach.delta < 0" class="fa fa-caret-down"></span>
    </div>
    <span *ngIf="breach.metricType==='Survival Horizon'" fxFlex="1 1 5%" class="fa fa-clock-o jump-to-history" fxFlexAlign="end" (click)="onHistory()"></span>
</div>